module.exports = __webpack_public_path__ + "img/MCS.27f2943d.png";